import React, { useState, useEffect } from 'react'
import { Table, ButtonGroup, Row } from 'rsuite'
import TooltipButton from '../../components/buttons/TooltipButton'
import { budgetFormat } from '../../utils/formatterUtil'
import TablePagination from 'rsuite/lib/Table/TablePagination'

export default function SubProjectAccountingReprotTable({
  schema,
  loading,
  page = 1,
  displayLength = 5,
  defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ],
  onReload = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])

  const fs = localStorage.getItem('fontSize')
  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const styleMainHeader = { textAlign: 'center', paddingTop: '1%', paddingBottom: '1%' }

  useEffect(() => {
    setTableData(schema?.values || [])
  }, [schema])

  const handleChangeLength = (dataKey) => {
    onReload(1, dataKey)
  }

  const handleChangePage = (dataKey) => {
    onReload(dataKey, displayLength)
  }

  return (
    <>
      <Table
        wordWrap
        bordered
        cellBordered
        height={540}
        minHeight={350}
        autoHeight={tableData.length < 10}
        hover
        //headerHeight={85}
        headerHeight={fs <= 15 ? 85 : fs < 16 ? 90 : fs <= 18 ? 95 : 100}
        loading={loading}
        data={tableData}
        style={{ marginTop: '20px' }}
      >
        <Column width={80}>
          <HeaderCell style={styleMainHeader}>ลำดับ</HeaderCell>
          <Cell align="center">
            {(_, index) => {
              return index + 1 + (page * displayLength - displayLength)
            }}
          </Cell>
        </Column>
        <Column width={fs <= 17 ? 130 : 150}>
          <HeaderCell style={styleMainHeader}>
            {/* <div style={styleHeaderCell}>เลขที่ข้อตกลง</div> */}
            <div style={styleHeaderCell}>รหัสโครงการ</div>
          </HeaderCell>
          {/* <Cell dataKey="contractNo" align="center" /> */}
          <Cell dataKey="projectCode" align="center" />
        </Column>

        <Column width={140}>
          <HeaderCell style={styleMainHeader}>
            <div style={styleHeaderCell}>หมวดกิจกรรม</div>
          </HeaderCell>
          <Cell dataKey="activityCode" />
        </Column>

        <Column width={300} minWidth={300} flexGrow={1}>
          <HeaderCell style={{ ...styleMainHeader }}>
            <div style={styleHeaderCell}>ชื่อโครงการ</div>
          </HeaderCell>
          <Cell dataKey="projectName" />
        </Column>

        <Column width={200}>
          <HeaderCell style={{ ...styleMainHeader }}>
            <div style={styleHeaderCell}>ผู้รับผิดชอบโครงการ</div>
          </HeaderCell>
          <Cell dataKey="responsinator" />
        </Column>

        <Column width={200}>
          <HeaderCell style={{ ...styleMainHeader }}>
            <div style={styleHeaderCell}>ระยะเวลาดำเนินงาน</div>
          </HeaderCell>
          <Cell dataKey="projectDuration" />
        </Column>
        <Column width={200} align="right">
          <HeaderCell style={{ ...styleMainHeader }}>
            <div style={styleHeaderCell}>งบประมาณโครงการย่อย (บาท)</div>
          </HeaderCell>
          <Cell>
            {(rowData) => {
              return budgetFormat(rowData.totalBudget)
            }}
          </Cell>
        </Column>
        <Column width={160} align="right">
          <HeaderCell style={{ ...styleMainHeader }}>
            <div style={styleHeaderCell}>โอนแล้ว (บาท)</div>
          </HeaderCell>
          <Cell>
            {(rowData) => {
              return budgetFormat(rowData.transferAmount)
            }}
          </Cell>
        </Column>
        <Column width={160} align="right">
          <HeaderCell style={{ ...styleMainHeader }}>
            <div style={styleHeaderCell}>งบประมาณค้างโอน (บาท)</div>
          </HeaderCell>
          <Cell>
            {(rowData) => {
              return budgetFormat(rowData.transferOverdue)
            }}
          </Cell>
        </Column>
        <Column width={160} align="right">
          <HeaderCell style={{ ...styleMainHeader }}>
            <div style={styleHeaderCell}>รับคืนจากโครงการ</div>
          </HeaderCell>
          <Cell>
            {(rowData) => {
              return budgetFormat(rowData.returnAmount)
            }}
          </Cell>
        </Column>
      </Table>

      <TablePagination
        lengthMenu={defaultLengthMenu}
        activePage={page}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 5}
        total={schema?.totalSize || 0}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />
    </>
  )
}
